export default __webpack_public_path__ + "09bd3502e526ddcc76bdefb7748575f7.svg";